<template>
  <div ref="target"><slot></slot></div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import useSetCssHeightVariable from '@app/shared/vue/composables/use-set-css-height-variable'

interface Props {
  variableName: string
}

const props = defineProps<Props>()

const target = ref<HTMLElement | null>(null)

useSetCssHeightVariable(target, props.variableName)
</script>
